import { isAd, getSensorsServerUrl } from './index'

export const initSensors = async () => {
  if (isAd) {
    const { default: sensors } = await import('sa-sdk-javascript')
    sensors.init({
      server_url: getSensorsServerUrl(),
    })
    // 注册公共属性
    sensors.registerPage({
      platform_type: 'PC_web',
    })
  }
}
